/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveVideoLinksViewProps } from './eve-video-links';
import Msdyn365 from '@msdyn365-commerce/core';

export default (props: IEveVideoLinksViewProps) => {
    const { renderLinks } = props;
    if (Msdyn365.isBrowser) {
        const containers = document.querySelectorAll('.image-video-container');
        containers.forEach(container => {
            container.addEventListener('mouseenter', () => {
                container.classList.add('overlay');
                const video = container.querySelector('.video') as HTMLVideoElement;
                if (video) {
                    void video.play();
                }
            });
            container.addEventListener('mouseleave', () => {
                container.classList.remove('overlay');
                const video = container.querySelector('.video') as HTMLVideoElement;
                if (video) {
                    void video.pause();
                    video.currentTime = 0;
                }
            });
        });
    }
    return <div id='home-videos'>{renderLinks}</div>;
};
